import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BannerType } from '../../../environments/common';

@Component({
  selector: 'card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss']
})
export class CardListComponent  implements OnInit, AfterViewChecked {
  @Input() items: any[];
  @Input() show: boolean;
  @Input() banner: BannerType;
  @Input() page: number;

  position: number = 3;
  size: number = 9;

  bannerPosition: boolean[];

  itemsCard: any[];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.updateBanner();
  }

  ngAfterViewChecked() {
    this.updateBanner();
    this.cdr.detectChanges(); // Marca el componente para la detección de cambios
  }

  updateBanner(){
    this.bannerPosition = Array(this.items.length).fill(false);

    for (let i = this.position; i < this.items.length; i += this.size) {
      this.bannerPosition[i] = true;
    }
    if(this.bannerPosition.length <= this.position){
      this.bannerPosition[this.bannerPosition.length-1] = true;
    }
  }

}
